import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'

export default withStyles({
	tooltip: {
		fontSize: 12,
		whiteSpace: 'pre-line',
	},
})(Tooltip)



// WEBPACK FOOTER //
// ./src/components/Material/Tooltip.js